import React, { lazy, Suspense } from 'react';

import AppLoader from './Router/AppLoader';

import '../assets/css/layout.scss';
import '../assets/css/app.scss';

const App = lazy(() => import('./App'));

const Root = (
    <Suspense fallback={<AppLoader />}>
        <App />
    </Suspense>
);

export default Root;
